import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilteredVehicle } from '../types';
import type { RootState } from './index';

interface VehicleReducerTypes {
  vehiclesList: FilteredVehicle[];
  // isLoading: boolean;
  totalCount: number | null;
}

const initialState: VehicleReducerTypes = {
  vehiclesList: [],
  // isLoading: false,
  totalCount: null,
};

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    setVehicles: (_state, action: PayloadAction<VehicleReducerTypes>) => {
      return action.payload;
    },
    addMoreVehicles: (state, action) => {
      const newVehiclesList = [...state.vehiclesList, ...action.payload];
      return { ...state, vehiclesList: newVehiclesList };
    },
  },
});

export const selectVehicles = (state: RootState) => state.vehicles;

export const { setVehicles, addMoreVehicles } = vehiclesSlice.actions;

export default vehiclesSlice.reducer;
